//imports
import React, { useState, useEffect } from "react";
import {
  Box,
  Link,
  Breadcrumbs,
  Stack,
  Button,
  Grid,
  AppBar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Toolbar,
  Typography,
  CircularProgress,
  Snackbar,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useNavigate, useLocation } from "react-router-dom";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Navbar from "../../components/common/Navbar";
import { useStyles } from "../../assets/styles/Theme";
import {
  externaldeleteApi,
  externalgetApi,
} from "../../services/external/externalApis";
import { ORDER_API_04, ORDER_API_08 } from "../../api/ApiModel";
import { useSelector } from "react-redux";
import {
  CON_STATUS_ACTIVE,
  CON_STATUS_DELETED,
  CON_STATUS_PENDING,
} from "../../utils/sys/Constants";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import currencyFormat from "../../utils/common/CurrencyFormat";
function Ordercancel() {
  //hooks
  const theme = useTheme();
  const styles = useStyles(theme);
  const navigate = useNavigate();
  const location = useLocation();
  const { ORDERCODE } = location.state || {};
  const [orderData, setOrderData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success"); // New state for snackbar severity
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, LOCCODE, RESTCODE, USERNAME } = SYS_USER.USER_PARAM || {};

  useEffect(() => {
    fetchOrderData();
  }, [ORDERCODE]);

  const fetchOrderData = async () => {
    setIsLoading(true);
    try {
      const orderResult = await externalgetApi(ORDER_API_04, "get", {
        ORDERCODE,
      });
      console.log("API response:", orderResult);

      const filteredData = Object.values(orderResult)
        .flat()
        .filter((item) => item && item.MENUNAME);

      setOrderData(filteredData);
    } catch (err) {
      console.error("Error fetching order data:", err);
      setError("Failed to load order data");
    } finally {
      setIsLoading(false);
    }
  };
  //delete api

  const handleDeleteConfirmation = () => {
    setOpenDialog(true);
  };

  const handleDelete = async () => {
    try {
      await externaldeleteApi(ORDER_API_08, "DELETE", {
        COMPCODE,
        LOCCODE,
        RESTCODE,
        ORDERCODE: ORDERCODE,
        STS: CON_STATUS_DELETED,
        ENUSER: USERNAME,
      });

      setSnackbarMessage("Order Canceled successfully!");
      setSnackbarSeverity("success"); // Set severity to success
      setOpenSnackbar(true);
      setOrderData([]); // Clear order data on successful delete
      setTimeout(() => {
        navigate("/orderlist");
      }, 2000);
    } catch (error) {
      console.error("Failed to delete order:", error);
      setSnackbarMessage("Failed to delete the order.");
      setSnackbarSeverity("error"); // Set severity to error
      setOpenSnackbar(true);
    } finally {
      setOpenDialog(false); // Close the dialog after delete attempt
    }
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
    setError(null);
  };

  const gotToView = () => {
    navigate("/orderlist");
  };

  return (
    <div>
      <Navbar />
      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer1}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs2}
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="none" href="/">
                  Home
                </Link>
                <Link underline="none">Setting</Link>
                <Link underline="none">Ordercancel</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack
                sx={{
                  ...styles.AI_fixedStack,
                  direction: "row",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  onClick={gotToView}
                  variant="contained"
                  startIcon={<ArrowBackIcon />}
                  sx={{
                    background: theme.palette.primary.main,
                    color: theme.palette.text.buttontxt,
                    textTransform: "capitalize",
                    letterSpacing: "1px",
                    width: "80px",
                  }}
                >
                  Back
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>

      <Box sx={styles.AddStyledBox}>
        <Toolbar
          sx={{
            maxWidth: "100%",
            pl: { sm: 2 },
            pr: { xs: 1, sm: 1 },
            background: theme.palette.background.paper,
            marginTop: { xs: "170px", md: "155px" },
          }}
        >
          <Typography
            variant="h6"
            component="div"
            sx={{
              color: theme.palette.text.primary,
              flex: "1 1 100%",
              ml: 1,
            }}
          >
            Order Number: {ORDERCODE}
          </Typography>
          <Stack direction="row" spacing={2} justifyContent="flex-end" p={2}>
            <Button
              variant="contained"
              sx={{
                background: theme.palette.primary.main,
                color: theme.palette.text.buttontxt,
                textTransform: "capitalize",
                width: "120px",
              }}
              onClick={handleDeleteConfirmation}
            >
              Cancel order
            </Button>
          </Stack>
        </Toolbar>

        {isLoading ? (
          <CircularProgress sx={{ display: "block", margin: "auto", mt: 5 }} />
        ) : (
          <TableContainer component={Paper} sx={styles.VI_ViewStyledPaper}>
            <Table sx={{ minWidth: 650 }} aria-label="order table">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: "bold", cursor: "pointer" }}>
                    Menu Name
                  </TableCell>
                  <TableCell
                    sx={{ fontWeight: "bold", cursor: "pointer" }}
                    align="center"
                  >
                    Quantity
                  </TableCell>
                  <TableCell
                    sx={{ fontWeight: "bold", cursor: "pointer" }}
                    align="right"
                  >
                    Rate
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {orderData.map((item, index) => (
                  <TableRow key={index}>
                    <TableCell component="th" scope="row">
                      {item.MENUNAME}
                    </TableCell>
                    <TableCell align="center">{item.QTY}</TableCell>
                    <TableCell align="right">
                      {currencyFormat(item.RATE)}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Box>

      {error && (
        <Snackbar
          open={!!error}
          autoHideDuration={6000}
          onClose={handleCloseSnackbar}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Alert severity="error" onClose={handleCloseSnackbar}>
            {error}
          </Alert>
        </Snackbar>
      )}

      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert severity={snackbarSeverity} onClose={handleCloseSnackbar}>
          {snackbarMessage}
        </Alert>
      </Snackbar>

      <Dialog open={openDialog} onClose={handleCloseDialog}>
        <DialogTitle>Confirm Cancellation</DialogTitle>
        <DialogContent>
          <Typography>Are you sure you want to Cancel this order?</Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleCloseDialog}
            sx={{
              background: theme.palette.primary.main,
              color: theme.palette.text.buttontxt,
              textTransform: "capitalize",
              borderRadius: 2,
              width: "100px",
              px: 3,
              "&:hover": {
                background: theme.palette.primary.main,
              },
            }}
            color="primary"
          >
            No
          </Button>
          <Button
            onClick={handleDelete}
            sx={{
              backgroundColor: theme.palette.system.danger,
              color: theme.palette.background.paper,
              textTransform: "capitalize",
              borderRadius: 2,
              width: "100px",
              px: 3,
              "&:hover": {
                backgroundColor: theme.palette.system.danger,
              },
            }}
            color="secondary"
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default Ordercancel;
